export default "__VITE_ASSET__f55d677d__"